<div class="threat-simulation-trial-page bs-enabled">
	<!-- Background decoration -->
	<div class="trial-bg-decoration"></div>

	<div class="trial-content">
		<!-- Badge -->
		<div class="trial-badge">
			<i class="far fa-gift"></i>
			<span>Limited Time Offer</span>
		</div>

		<!-- Hero Section -->
		<div class="trial-hero">
			<h1 class="trial-title">
				Try <span class="highlight">Threat Simulation</span> Free for 7 Days
			</h1>
			<p class="trial-subtitle">
				Transform your organization's security awareness with AI-powered phishing simulations and training campaigns
			</p>
		</div>

		<!-- CTA Button -->
		<div class="trial-cta-section cursor-pointer"
			 (click)="startFreeTrial()">
			<div class="trial-cta-btn flex-row gap-2 align-items-center text-white">
				<ng-container *ngIf="!startingTrial">
					<i class="far fa-rocket"></i>
					<span>Start Your Free Trial</span>
				</ng-container>
				<div class="loading-spinner" style="border-color: white; height: 30px; width: 30px;" *ngIf="startingTrial"></div>
			</div>
			<span class="trial-cta-note">No credit card required</span>
		</div>

		<!-- Features Grid -->
		<div class="trial-features">
			<div class="feature-card">
				<div class="feature-icon ai-icon">
					<i class="far fa-brain"></i>
				</div>
				<h3>AI-Powered Content Generation</h3>
				<p>Create hyper-realistic phishing emails in seconds using advanced AI. Generate context-aware simulations tailored to your industry and organization.</p>
			</div>

			<div class="feature-card">
				<div class="feature-icon simulation-icon">
					<i class="far fa-envelope-open-text"></i>
				</div>
				<h3>Realistic Phishing Simulations</h3>
				<p>Deploy sophisticated attack simulations that mirror real-world threats. Test your employees with scenarios they'll actually encounter.</p>
			</div>

			<div class="feature-card">
				<div class="feature-icon training-icon">
					<i class="far fa-graduation-cap"></i>
				</div>
				<h3>Interactive Training Materials</h3>
				<p>Deliver engaging security awareness training with videos, quizzes, and interactive modules that boost retention and compliance.</p>
			</div>

			<div class="feature-card">
				<div class="feature-icon analytics-icon">
					<i class="far fa-chart-line"></i>
				</div>
				<h3>Comprehensive Analytics</h3>
				<p>Track click rates, report rates, and training completion. Identify vulnerable departments and measure improvement over time.</p>
			</div>
		</div>

		<!-- AI Highlight Section -->
		<div class="ai-highlight-section">
			<div class="ai-highlight-content">
				<div class="ai-badge">
					<i class="far fa-sparkles"></i>
					<span>NEW</span>
				</div>
				<h2>Supercharge Your Training with AI</h2>
				<ul class="ai-features-list">
					<li>
						<i class="far fa-check-circle"></i>
						<span>Generate custom phishing templates in seconds</span>
					</li>
					<li>
						<i class="far fa-check-circle"></i>
						<span>AI analyzes your organization to create targeted scenarios</span>
					</li>
					<li>
						<i class="far fa-check-circle"></i>
						<span>Automatically adapt difficulty based on employee performance</span>
					</li>
					<li>
						<i class="far fa-check-circle"></i>
						<span>Smart recommendations for training improvements</span>
					</li>
				</ul>
			</div>
			<div class="ai-highlight-visual">
				<div class="ai-visual-card">
					<div class="ai-visual-header">
						<i class="far fa-robot"></i>
						<span>AI Assistant</span>
					</div>
					<div class="ai-visual-body">
						<div class="ai-typing-indicator">
							<span></span><span></span><span></span>
						</div>
						<p>Generating a spear-phishing simulation targeting your finance team...</p>
					</div>
				</div>
			</div>
		</div>

		<!-- Bottom CTA -->
		<div class="trial-bottom-cta cursor-pointer"
			 (click)="startFreeTrial()">
			<div class="trial-cta-btn large flex-row gap-2 align-items-center text-white">
				<ng-container *ngIf="!startingTrial">
					<i class="far fa-rocket"></i>
					<span>Start Free 7-Day Trial</span>
				</ng-container>
				<div class="loading-spinner" style="border-color: white; height: 30px; width: 30px;" *ngIf="startingTrial"></div>
			</div>
			<p class="trial-contact-note">
				Have questions?
				<a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tickets]" [state]="{ data: 'open' }">
					Contact our team
				</a>
			</p>
		</div>
	</div>
</div>
